import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { icons } from '../../../assets/icons';
import { Link, useParams } from 'react-router-dom';
import './index.scss';
import { useDispatch } from 'react-redux';
import { getUserDetails } from '../../../api/redux/slices/Admin';
import { LoaderComponent } from '../../../helpers/components/loader';
import { convertCategory, convertRegulation } from '../../../helpers/modules';

const UserDetails = () => {
	const [infos, setInfos] = useState({});
	const [countryMap, setCountryMap] = useState({});
	const [countryNames, setCountryNames] = useState({});
	const params = useParams();
	const token = localStorage.getItem('accesstoken');
	const [isLoading, setIsLoading] = useState(false);
	const dispatch = useDispatch();

	useEffect(() => {
    fetch('https://cdn.jsdelivr.net/npm/world-countries@4/dist/countries.json')
        .then(res => res.json())
        .then(data => {
            const map = {};
            const names = {};
            data.forEach(c => {
                if (c?.cca3 && c?.cca2 && c?.name?.common) {
                    map[c.cca3] = c.cca2.toLowerCase();
                    names[c.cca3] = c.name.common;
                }
            });
            setCountryMap(map);
            setCountryNames(names);
        })
        .catch(err => console.error('Failed to fetch country codes:', err));
}, []);

	const getFlagUrl = (cca3) => {
		if (!cca3 || !countryMap[cca3]) return null;
		return `https://hatscripts.github.io/circle-flags/flags/${countryMap[cca3]}.svg`;
	};

	const getCountryName = (cca3) => {
		return countryNames[cca3] || cca3;
	};

	const stableDispatch = useCallback(() => {
		setIsLoading(true);
		dispatch(getUserDetails({ token: token, id: params.id }))
			.unwrap()
			.then((res) => setInfos(res.data))
			.finally(() => setIsLoading(false));
	}, [dispatch, params.id, token]);

	useEffect(() => { stableDispatch(); }, [stableDispatch]);

	if (isLoading) return <LoaderComponent />;

	return (
		<div id='user-details'>
			<div className='details-user-header'>
				<Link to={`/admin/users/${params.page}`}>
					<icons.BsArrowLeft style={{ color: '#5B5B5B', marginRight: '10px' }} />
					<h1>Liste d'utilisateurs</h1>
				</Link>
				<Link to={`/admin/users/update_user/${params.page}/${params.id}`}>
					<button className='button-primary'>Modifier</button>
				</Link>
			</div>
			<div className='container'>
				<div className='user-type'>
					<h3>Type d'utilisateur</h3>
					<div className='line'><label>Utilisateur</label><span>{infos.role === 'customer' ? 'Client' : infos.role}</span></div>
				</div>
				{infos.role === 'customer' && (
					<>
						<div className='user-type'>
							<h3>Type de catégorie</h3>
							<div className='line'><label>Catégorie</label><span>{infos.categories ? convertCategory(infos.categories) : '-'}</span></div>
						</div>
						<div className='user-type'>
							<h3>Type de réglément</h3>
							<div className='line'><label>Réglément</label><span>{infos.regulation ? convertRegulation(infos.regulation) : '-'}</span></div>
						</div>
					</>
				)}
				<div className='user-type'>
					<h3>Information générale</h3>
					<div className='line'><label>Nom</label><span>{infos.first_name}</span></div>
					<div className='line'><label>Prénom</label><span>{infos.last_name}</span></div>
					<div className='line'><label>Email</label><span>{infos.email}</span></div>
					{infos.role === 'customer' && <div className='line'><label>Référence code client</label><span>{infos.customs_code}</span></div>}
					<div className='line'><label>N° de téléphone</label><span>{infos.phone}</span></div>
					<div className='line'><label>Nom de société</label><span>{infos.company_name || '-'}</span></div>
					<div className='line'><label>Matricule fiscal</label><span>{infos.tax_registration_number}</span></div>
					{infos?.created_By?.first_name && (
						<div className='line'><label>Créé par</label><span>{infos?.created_By?.first_name} {infos?.created_By?.last_name}</span></div>
					)}
				</div>
				{infos.role === 'customer' && <h3>Liste des boutiques</h3>}
				{infos.role === 'customer' && infos.shop.map((boutique) => (
					<Fragment key={boutique._id}>
						<div className='user-type'>
							<div className='line'>
								<label>{boutique.name}</label>
								<span>
									{boutique.country && getFlagUrl(boutique.country) ? (
										<img 
											src={getFlagUrl(boutique.country)}
											alt={getCountryName(boutique.country)}
											width="22"
											height="22"
											style={{ marginRight: '6px', verticalAlign: 'middle', borderRadius: '50%' }}
										/>
									) : null}
									{boutique.country && (
										<strong style={{ marginRight: '4px' }}>{getCountryName(boutique.country)}</strong>
									)}
									{boutique.region && `${boutique.region}, `}
									{boutique.address_number} {boutique.street} {boutique.postal_code} {boutique.ville}
								</span>
							</div>
						</div>
					</Fragment>
				))}
			</div>
		</div>
	);
};

export default UserDetails;